export default {
  props: {
    background: {
      type: Object,
    },
    title: {
      type: Object,
    },
    body: {
      type: String,
    },
    downloadButtons: {
      type: Array,
    },
  },
}
